import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import "@vetixy/circular-std";
import { useState } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "../ArrowBackIcon";

type AfterSendingLinkProps = {
  userEmail: string;
};

const AfterSendingLinkSection = ({ userEmail }: AfterSendingLinkProps) => {
  const [isReceivedMail, setIsReceivedMail] = useState(false);
  const supportEmail = "hello@viralprofits.yt";

  return (
    <>
      <Flex
        as="form"
        p={{ base: "0", md: "0" }}
        w={{ base: "100%", md: "508px" }}
        margin="0 auto"
        bg="#fff"
        border="1px solid #EAECF0"
        borderRadius="15px"
        flexDirection="column"
        boxShadow="0px 24px 48px 0px #0000000A"
      >
        <Heading
          p={{ base: "20px 16.5px 0", md: "40px 36px 0" }}
          mb="28px"
          display="flex"
          justifyContent="center"
        >
          <img
            src="/images/viral-logo.webp"
            alt="viral-logo"
            height="18"
            width="107"
          />
        </Heading>

        <Text
          fontWeight="700"
          fontSize="24px"
          lineHeight="30.36px"
          textAlign="center"
        >
          Access Incoming 📧
        </Text>

        <Text
          fontSize="16px"
          mt="20px"
          mb="40px"
          // mx="40px"
          mx={{ base: "30px", md: "40px" }}
          fontWeight="450"
          lineHeight="20.24px"
          textAlign="center"
        >
          We’ve sent an email to
          <Box color="primary" as="span">
            {" "}
            {userEmail}{" "}
          </Box>
          with a temporary access link.
        </Text>

        <Box
          borderTop="1px solid #eaecf0"
          cursor="pointer"
          onClick={() => {
            setIsReceivedMail(!isReceivedMail);
          }}
          color={isReceivedMail ? "#D92D20" : "#000000"}
          background={isReceivedMail ? "#FEF3F2" : "#FFFFFF"}
          borderRadius="0px 0px 14px 14px"
        >
          <Text
            fontWeight="450"
            fontSize="14px"
            my="16px"
            lineHeight="17.1px"
            textAlign="center"
          >
            I haven’t received an email. What should I do?
          </Text>
        </Box>
      </Flex>

      {isReceivedMail && (
        <div className="mt-5 flex flex-col gap-2.5 rounded-[15px] border border-[#EAECF0] bg-white px-4.5 py-3">
          <div className="flex items-center gap-2.5">
            <div className="grid min-h-[26px] min-w-[26px] place-items-center rounded-[9px] bg-[#F5F5F5]">
              <ArrowBackIcon color="black" size={14} />
            </div>

            <Text fontWeight="450" fontSize="14px" lineHeight="17.1px">
              Check your spam folder
            </Text>
          </div>

          <div className="flex items-center gap-2.5">
            <div className="grid min-h-[26px] min-w-[26px] place-items-center rounded-[9px] bg-[#F5F5F5]">
              <ArrowBackIcon color="black" size={14} />
            </div>

            <Text fontWeight="450" fontSize="14px" lineHeight="17.1px">
              <Link to={`mailto:${supportEmail}`}>
                Time to call in backup. Email us at {supportEmail}
              </Link>
            </Text>
          </div>
        </div>
      )}
    </>
  );
};

export default AfterSendingLinkSection;
